import { HOUSEHOLD_STEPS } from '@flows/configs/householdAt/constants'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_HouseholdV1GetsafeAt } from '@flows/insurance/schemas'

const household_at_flood_area = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('flood_area')]:
        BaseSchema_HouseholdV1GetsafeAt.shape.flood_area.unwrap(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_householdAt:steps.flood_area.title',
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('flood_area'),
        options: [
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_householdAt:steps.flood_area.floodAreaOptions.no',
            },
            value: 'none',
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_householdAt:steps.flood_area.floodAreaOptions.low',
            },
            value: 'hq_300',
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_householdAt:steps.flood_area.floodAreaOptions.mid',
            },
            value: 'hq_100',
          },
        ],
      },
      {
        type: 'infoBox',
        contentSpaceSize: 'none',
        showInfoIcon: true,
        contentConfiguration: [
          {
            type: 'title',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_householdAt:steps.flood_area.infoTitle',
            },
          },
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_householdAt:steps.flood_area.infoSubtitle1',
            },
          },
          {
            type: 'spacer',
            size: 'small',
          },
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_householdAt:steps.flood_area.infoSubtitle2',
            },
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStep: HOUSEHOLD_STEPS.household_at_prev_insurance,
  }) as const satisfies AnyStepConfiguration

export default household_at_flood_area
